export enum ELoopSteps {
  INFO,
  SETTINGS,
  MEASUREMENT,
  RESULT,
}
